import { createSelector } from '@reduxjs/toolkit';

import { ICultureDTO, IPreferencesDTO } from 'src/api/dtos';
import { mapLanguageIdEnums } from 'src/shared/utils';
import { RootState } from 'src/store/types';

const selectSelf = (state: RootState) => state.localizations;
const selectUser = (state: RootState) => state.user;

export const getCurrentCulture = createSelector([selectSelf, selectUser], ({ cultures }, { preferences }) => {
  return getCulture(preferences, cultures, 'name');
});

export const getCurrentCultureDisplayName = createSelector(
  [selectSelf, selectUser],
  ({ cultures }, { preferences }) => {
    return getCulture(preferences, cultures, 'displayName');
  },
);

const getCulture = (
  preferences: IPreferencesDTO | null,
  cultures: ICultureDTO[],
  key: keyof Pick<ICultureDTO, 'name' | 'displayName'>,
): string => {
  const id = preferences?.languageId;
  const defaultLang: string = id ? mapLanguageIdEnums[id] : navigator.language;

  if (!cultures) {
    return defaultLang;
  }

  const culture = cultures.find((c) => c.id === id);

  if (!culture || !culture[key]) {
    return defaultLang;
  }

  return culture[key];
};
